<div class="modal-popup" id="modal-popup">
  <div class="modal-popup-content">
    <div class="close-button-container">
      <button type="button" class="close" (click)=onClickClosePopup()>
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="popup-heading">
      <h1>{{constants.YOUR_WINDOW_TXT}}</h1>
    </div>
    <div class="img-container">
      <img src="{{constants.POPUP_MYWINDOW_IMG}}" alt="">
    </div>
    <div class="popup-content">
      <p>{{constants.WE_UPLOAD_TXT }}</p>
      <p>{{constants.YOUR_MIGHT_TXT}}</p>
    </div>
  </div>
</div>
<div class="modal-popup" id="modal-popup-confirm">
  <div class="confirm-popup-content">
    <div class="popup-content-confirm">
      <h1>{{constants.ARE_YOU_TXT}}</h1>
      <button [disabled]="isRemoving" type="button" class="yes-button" (click)="onClickRemove()">
        <div *ngIf="isRemoving" class="spinner-border removing-spinner text-light" role="status">
          <span class="sr-only">{{constants.LOADING_TEXT}}</span>
        </div>
        <div *ngIf="!isRemoving">{{constants.YES}}</div>
      </button>
      <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
        {{constants.NO}}
      </button>
    </div>
  </div>
</div>

<div class="modal-popup" id="delete-modal-popup-confirm">
  <div class="confirm-popup-content">
    <div class="popup-content-confirm">
      <h1>{{constants.DELETE_TEXT}}</h1>
      <button [disabled]="isRemoving" type="button" class="secondyes-button" (click)=onClickRemove() >
          <span *ngIf="isRemoving" class="spinner-border spinner-border-sm name-update-spinner" role="status"
          aria-hidden="true"></span>
          {{isRemoving ? '' : constants.YES}}
      </button>
      <button type="button" class="cancel-button" (click)=closeDialog()>
        Cancel
      </button>
    </div>
  </div>
</div>
<div *ngIf="isLoading">
  <div class="row" *ngFor="let item of skeltonArray">
    <div class="col-md-6">
      <img class=" card-img-skelton" src="{{item}}" alt="">
    </div>
    <div class="col-md-6">
      <img class=" card-img-skelton" src="{{item}}" alt="">
    </div>
  </div>
</div>
<div class="container" *ngIf="!isEmptyWindow">
  <div class="confirm">
    <button type="button" id="confirm" class="btn btn-dark">{{constants.YOUR_TXT}}</button>
  </div>
  <div class="row">
    <div class="col-md-6 column" *ngFor="let item of uploadedArray" >

      <div class="shift-date d-md-none">
        <div>
          <p class="date">{{item.uploadedOn}}</p>
        </div>
      
        <div class=" image-container col-md-6" (click)="onClickVideoTitle(item)">
          <img class="card-img" src="{{item.url}}" alt="">
        </div>
      </div>
        
      

      <div class=" col-6 image-container d-none d-md-block" (click)="onClickVideoTitle(item)" >
        <img class="card-img" src="{{item.url}}" alt="">
      </div>
      <div class=" col-6 content-container">
        <div class="d-none d-md-block">
          <p class="date " >{{item.uploadedOn}}</p>
          <span class="title truncate" data-toggle="tooltip" data-placement="top" title="{{fetchCity(item)}}">{{fetchCity(item)}}</span>
          <div class="bookmark">
            <img [src]="constants.FAVORITE_IMG" alt="" height="auto" width="14px">
            <span class="view-count view-count-margin2"> {{item.bookmarkCount}}</span>
            <span class="view-text"> {{constants.BOOKMARK_TXT}}</span>
          </div>
      
          <div>
            <img [src]="constants.VIEW_IMG" alt="" >
            <span class="view-count view-count-margin1"> {{item.view}}</span>
            <span class="view-text"> {{constants.VIEW_TXT}}</span>
          </div>
        </div>

        <div class="mobile-margin d-md-none">
          <span class="title truncate-mobile" data-toggle="tooltip" data-placement="top" title="{{fetchCity(item)}}">{{fetchCity(item)}}</span>
          <div class="bookmark">
            <img [src]="constants.FAVORITE_IMG" alt="" height="auto" width="14px">
            <span class="view-count view-count-margin2"> {{item.bookmarkCount}}</span>
            <span class="view-text"> {{constants.BOOKMARK_TXT}}</span>
          </div>
      
          <div>
            <img [src]="constants.VIEW_IMG" alt="" >
            <span class="view-count view-count-margin1"> {{item.view}}</span>
            <span class="view-text"> {{constants.VIEW_TXT}}</span>
          </div>
        </div>
        
        
        <div class="card-button">
          <!-- <div (click)="openDialog(item)" class="deleteCursor">
            <img [src]="constants.DELETE_IMG" alt=""  class="delete-img">
            <span class="delete-text"> DELETE</span>
            
          </div> -->
        </div>
      </div>
    </div>
    <div class="col-md-6 column" id="{{item.videoName}}" *ngFor="let item of queueArray">
      
      <div class="shift-date d-md-none">
        <div >
          <p class="date">{{item.createdAt}}</p>
        </div>

        <div class="image-container-queue col-md-6">
          <img [src]="item.thumbnail || constants.BROKEN_IMG" alt=""/>
        </div>
      </div>
        
      <div class="image-container-queue d-none d-md-block">
        <img [src]="item.thumbnail || constants.BROKEN_IMG" alt=""/>
      </div>
      
      <div class=" col-6 content-container">
    
        <div class="editButton d-none d-md-block">
          <div>
            <p class="date">{{item.createdAt}}</p>
            <span class="title truncate" data-toggle="tooltip" data-placement="top" title="{{item.cityLocation}}">{{item.cityLocation}}</span>
          </div>
          <div class="queue-button-container bookmark">
            <button (click)="onClickShowPopup()" class="queue-button btn">{{constants.IN_QUEUE_TXT}}</button>
          </div>
    
        </div>

        <div class="editButton-mobile d-md-none">
          <div>
            <span class="title truncate-mobile" data-toggle="tooltip" data-placement="top" title="{{item.cityLocation}}">{{item.cityLocation}}</span>

          </div>
          <div class="queue-button-container bookmark">
            <button (click)="onClickShowPopup()" class="queue-button btn">{{constants.IN_QUEUE_TXT}}</button>
          </div>
    
        </div>

        <div class="edit-position d-md-none">
          <span (click)="openMobileEditDialog(item)"> <img [src]="constants.EDIT_BUTTON" alt="" class="delete-img2"> </span>
        </div>
    
        <!-- <div class="queue-button-container d-md-none">
         
          <div  (click)="openMobileEditDialog(item)">
            <img [src]="constants.EDIT_IMG" alt="" class="delete-img">
          </div>
    
        </div> -->


        <div>

          <div class="queue-button-container d-none d-md-block">
            <div class=" showEdit " (click)="openEditDialog(item)">
              <img [src]="constants.EDIT_IMG" alt="" class="delete-img">
              <span class="delete-text view-count-margin1">EDIT DETAILS</span>
      
            </div>
            <div class=" mobileEdit " (click)="openMobileEditDialog(item)">
              <img [src]="constants.EDIT_IMG" alt="" class="delete-img">
              <span class="delete-text view-count-margin1">EDIT DETAILS</span>
      
            </div>
      
            
      
          </div>
  
      
          <div class="queue-button-container d-none d-md-block">
      
            <div class=" showEdit " (click)="openDialog(item)">
              <img [src]="constants.DELETE_IMG" alt="" class="delete-img">
              <span class="delete-text view-count-margin1">DELETE</span>
      
            </div>
    
          </div>
          
        </div>



      </div>
    </div>
  </div>
</div>
<div class="container empty-bookmark" *ngIf="isEmptyWindow">
  <div class="row">
    <div class="col-12">
      <img class="empty-bookmark-img" [src]="constants.POPUP_BEFORE_IMG" alt="">
      <h4 class="empty-bookmark-heading">{{constants.COMING_SOON_TXT}}</h4>
      <p class="empty-bookmark-content large-screen">
        {{constants.YOU_WILL_SOON_TXT}}<br />{{constants.ON_THE_WINDOW_TXT}}
      </p>
      <p class="empty-bookmark-content small-screen">
        {{constants.YOU_WILL_SOON_TXT}}{{constants.ON_THE_WINDOW_TXT}}
      </p>
    </div>
  </div>
</div>